import React from "react";

export const PageHeader = ({ title, subtitle, action }) => {
    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
            <div>
                <h1 className="font-display font-bold text-2xl lg:text-3xl tracking-tight text-navy-900" data-testid="page-title">{title}</h1>
                {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
            </div>
            {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
        </div>
    );
};

export default PageHeader;
